const motivationalQuotes = [
  "Your journey in improving your typing skills is like a story. Each test taken, each word typed is a step forward.",
  "With dedication and practice, you're crafting your path to typing mastery.",
  "Embrace every challenge, for it brings you closer to your goals.",
  "Your progress reflects your commitment and hard work.",
  "Remember, success is built one keystroke at a time.",
  "Believe in your progress, even if it's one word at a time.",
  "Each test taken is a step towards unlocking your full potential.",
  "Stay focused on your goals, and let each keystroke carry you closer.",
  "Don't count the words, make every word count in your journey.",
  "Your typing journey is unique,compare yourself only to your past self.",
  "Celebrate every milestone, no matter how small, it's a step forward.",
  "Consistency turns into skills, and skills turn into mastery.",
  "Celebrate progress over perfection, for every effort counts.",
  "The journey of a thousand words begins with a single keystroke.",
  "Keep pushing your limits, for they expand with every practice.",
  "You're creating a legacy of growth with every test you take.",
  "Success comes to those who type through challenges.",
  "Stay patient and persistent, and you'll master typing.",
  "Every test taken is a step towards rewriting your typing story.",
  "Your keyboard is your canvas, paint your progress with each tap.",
  "You're not just typing, you're scripting your success story.",
  "Your typing journey is a marathon, not a sprint—keep pacing yourself.",
  "The only way to fail is to stop trying, keep typing!",
  "Embrace the journey of improvement, for it's where you find growth.",
  "Embrace the rhythm of your typing, it's a symphony of progress.",
  "Every error is a lesson, and every improvement is a victory.",
  "Believe in the power of practice, it's the fuel for your typing journey.",
  "Today's keystrokes are tomorrow's accomplishments.",
  "Stay curious and keep challenging yourself, you're on the path to greatness.",
];

export default motivationalQuotes;
